import { from } from "rxjs/observable/from";

// The page the user lands on after opening the app and without a session
export const FirstRunPage = 'LoginPage';

// The main page the user will see as they use the app over a long period of time.
// Change this if not using tabs
export const MainPage = 'ListMasterPage';

// The initial root pages for our tabs (remove if not using tabs)
export const Tab1Root = 'ListMasterPage';
export const Tab2Root = 'ListMasterPage';
export const Tab3Root = 'ListMasterPage';

export { LoginPage as LoginPageAproval} from './login/login';
export { ChronologyPage as ChronologyPageAproval } from './chronology/chronology';
export { DashboardPage as DashboardPageAproval } from './dashboard/dashboard';
export { ItemCreatePage as ItemCreatePageAproval } from './item-create/item-create';
export { ItemDetailPage as ItemDetailPageAproval } from './item-detail/item-detail';
export { ListMasterPage as ListMasterPageAproval } from './list-master/list-master';
export { ListTaskPageApproval } from './list-task/list-task';
export { MonitoringPage as MonitoringPageAproval } from './monitoring/monitoring';
export { ProfilePage as ProfilePageAproval } from './profile/profile';
export { TabsPage as TabsPageAproval } from './tabs/tabs';



// WEBPACK FOOTER //
// ./src/pages/aproval_erp/index.ts